const Cdt = {
  symbol: 'cdt',
  color: '#000',
  plainIcon: c => {
    return `<path fill="${
      c ? c : this.color
    }" d="M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm11-15.97C26.975 9.971 22.128 5.057 16.12 5v2.802c3.944-.002 7.316 2.863 7.984 6.782h-3.89c.15.458.228.935.234 1.416-.001.482-.08.96-.234 1.416h3.89c-.659 3.925-4.036 6.794-7.984 6.782V27c2.886 0 5.653-1.155 7.694-3.212A11.014 11.014 0 0 0 27 16.029zm-7.254 2.359a4.299 4.299 0 0 1-5.965 1.326c-2.011-1.295-2.6-3.988-1.316-6.015a4.299 4.299 0 0 1 5.965-1.327c.522.35.97.8 1.316 1.327h3.072c-1.136-3.305-4.472-5.3-7.893-4.72C11.505 9.56 9 12.547 9 16.044s2.505 6.484 5.925 7.064c3.421.58 6.757-1.414 7.893-4.72z"/>`;
  },
  colorIcon() {
    return `<g fill="none"><circle cx="16" cy="16" fill="#272731" r="16"/><path d="M27 16.03c0 2.91-1.145 5.7-3.186 7.758A10.832 10.832 0 0 1 16.12 27v-2.802c3.948.012 7.325-2.857 7.984-6.782h-3.89c.154-.456.233-.934.234-1.416a4.78 4.78 0 0 0-.234-1.416h3.89c-.668-3.92-4.04-6.784-7.984-6.782V5c6.008.058 10.855 4.972 10.88 11.03zm-7.254 2.359h3.072c-1.136 3.305-4.472 5.3-7.893 4.72C11.505 22.527 9 19.541 9 16.043s2.505-6.483 5.925-7.064c3.421-.58 6.757 1.415 7.893 4.72h-3.072a4.72 4.72 0 0 0-1.316-1.327 4.299 4.299 0 0 0-5.965 1.327c-1.284 2.027-.695 4.72 1.316 6.015a4.299 4.299 0 0 0 5.965-1.326z" fill="#fff"/></g>`;
  }
};
export default Cdt;



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-cryptoicon/src/icons/cdt.js
// module id = null
// module chunks = 